import {useEffect,useState} from 'react'

function Main() {

    const[v,setv]=useState('100')

  return (
    <>
        <div className="infopage">

            <h1>Welcome to Let's <span className='m'> M</span><span className='i'> I</span><span className='n'> N</span><span className='g'> G</span><span className='l'> L </span><span className='e'> E</span></h1>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.  </p>
            <div  className='pointer'/>
            <div className="updats"></div>
        </div>
    
    
    </>
  )
}

export default Main